import httpUtils from '../utils/http-utils';
import { API_PATH } from '../config/app-config';

// Programs (หลักสูตร) admin REST API — /api/v1/admin/programs
const SERVICE_NAME = API_PATH.PROGRAM;

const buildQuery = (condition = {}) => {
    const params = [];
    Object.keys(condition).forEach((key) => {
        const value = condition[key];
        if (value !== null && value !== undefined && value !== '') {
            params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
    });
    return params.length > 0 ? `?${params.join('&')}` : '';
}

// GET /api/v1/admin/programs?q=&level=&faculty=
const search = (condition = {}) => {
    return httpUtils.get(SERVICE_NAME + buildQuery(condition));
}

// GET /api/v1/admin/programs/{id}
const getById = (id) => {
    return httpUtils.get(`${SERVICE_NAME}/${encodeURIComponent(id)}`);
}

// POST /api/v1/admin/programs  (body = ProgramBean)
const add = (bean) => {
    return httpUtils.post(SERVICE_NAME, bean);
}

// PUT /api/v1/admin/programs/{id}  (body = ProgramBean)
const edit = (id, bean) => {
    return httpUtils.put(`${SERVICE_NAME}/${encodeURIComponent(id)}`, bean);
}

// DELETE /api/v1/admin/programs/{id}
const remove = (id) => {
    return httpUtils.del(`${SERVICE_NAME}/${encodeURIComponent(id)}`);
}

const programApi = {
    search,
    getById,
    add,
    edit,
    remove,
    buildQuery
}

export default programApi;
